(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7788],{

/***/ 46730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cadastro",
      function () {
        return __webpack_require__(19339);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Cadastro; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21757);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(68029);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88329);
/* harmony import */ var _components_SEO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27353);
/* harmony import */ var _layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81072);
/* harmony import */ var _contexts_LoadingContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28544);
/* harmony import */ var _components_Form_collapseLog__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44743);






function Cadastro() {
    var setActionIsLoading = (0,_contexts_LoadingContext__WEBPACK_IMPORTED_MODULE_3__/* .useLoading */ .r$)().setActionIsLoading;
    setActionIsLoading(false);
    var isWideVersion = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .useBreakpointValue */ .S)({
        base: false,
        xs: false,
        sm: false,
        md: false,
        lg: true,
        xl: true
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SEO__WEBPACK_IMPORTED_MODULE_1__/* .SEO */ .H, {
        title: "Loja Oficial LingLong - Fa\xe7a seu Cadastro",
        description: "Loja Oficial LingLong | Cadastro | Compre Pneus Online e Receba Super R\xe1pido. Promo\xe7\xf5es de pneus LingLong ✓ Menor Custo de Frete ✓ Compra Segura em at\xe9 12x.",
        path: "/cadastro",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_2__/* .Layout */ .Ar, {
            pt: "2rem",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout__WEBPACK_IMPORTED_MODULE_2__/* .ContentBox */ .Y_, {
                mt: !isWideVersion && "50px",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                    width: [
                        "90%",
                        "100%"
                    ],
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_7__/* .Flex */ .k, {
                        w: "100%",
                        direction: "column",
                        alignItems: "center",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Form_collapseLog__WEBPACK_IMPORTED_MODULE_4__/* .CollapseLog */ .N, {
                            startCreate: true
                        })
                    })
                })
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(46730); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);